import {DocumentRoutes} from './documents'
import {ChangeDependentRoutes} from './procedures/changeDependents'
import {ChildcareLeaveRoutes} from './procedures/childcareLeave'
import {RouteParams} from 'types/routes'
import {ProcedureNewRoutes} from './procedureNew'
import {StartChildcareRoutes} from './procedures/startChildcare'
import {ExtendChildcareRoutes} from './procedures/extendChildcare'
import {FinishChildcareRoutes} from './procedures/finishChildcare'
import {ParentalLeaveRoutes} from './procedures/parentalLeave'
import {ParentalLeaveSupportAllowanceRoutes} from './procedures/parentalLeaveSupportAllowance'

export const mypageRoutes: RouteParams[] = [
  ...DocumentRoutes,
  ...ChangeDependentRoutes,
  ...ChildcareLeaveRoutes,
  ...StartChildcareRoutes,
  ...ExtendChildcareRoutes,
  ...FinishChildcareRoutes,
  ...ParentalLeaveRoutes,
  ...ParentalLeaveSupportAllowanceRoutes,
  ...ProcedureNewRoutes,
]
